import React, { useRef, useEffect } from 'react';
import { Canvas, useFrame, useLoader as useThreeLoader } from '@react-three/fiber'; // Rename to avoid conflict with custom hook
import { TextureLoader } from 'three';
import { OrbitControls, Stars, Float } from '@react-three/drei';
import { useLoader } from '../../context/LoaderContext'; // Custom hook
import { useLocation } from 'react-router-dom';

const Logo = () => {
    const mesh = useRef();
    const texture = useThreeLoader(TextureLoader, '/logo.png');

    useFrame((state) => {
        mesh.current.rotation.y += 0.01;
        mesh.current.rotation.x = Math.sin(state.clock.elapsedTime) * 0.1;
    });

    return (
        <Float speed={2} rotationIntensity={0.5} floatIntensity={1}>
            <mesh ref={mesh}>
                <planeGeometry args={[3, 1]} /> {/* Adjust aspect ratio for logo */}
                <meshBasicMaterial map={texture} transparent opacity={1} side={2} /> {/* Double sided */}
            </mesh>
        </Float>
    );
};

const ThreeDLoader = () => {
    const { loading, progress, setLoading } = useLoader();
    const location = useLocation();

    useEffect(() => {
        const hasVisited = sessionStorage.getItem('cdp3d_visited');
        
        if (location.pathname !== '/' || hasVisited) {
            setLoading(false);
        } else {
            // First time on Home
            sessionStorage.setItem('cdp3d_visited', 'true');
            // Keep loading true (default) until assets load
        }
    }, [location.pathname, setLoading]);

    if (!loading) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            zIndex: 9999,
            background: 'radial-gradient(circle at center, #1a1a1a 0%, #000000 100%)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'opacity 0.5s ease',
        }}>
            <div style={{ width: '100%', height: '60%' }}>
                <Canvas camera={{ position: [0, 0, 5], fov: 50 }}>
                    <ambientLight intensity={0.5} />
                    <pointLight position={[10, 10, 10]} />
                    <Stars radius={100} depth={50} count={5000} factor={4} saturation={0} fade speed={1} />
                    <Logo />
                    <OrbitControls enableZoom={false} autoRotate autoRotateSpeed={2} />
                </Canvas>
            </div>
            
            <div style={{ textAlign: 'center', marginTop: 20 }}>
                <h2 style={{ 
                    color: 'white', 
                    fontFamily: 'sans-serif', 
                    fontSize: '2rem', 
                    marginBottom: 10,
                    textTransform: 'uppercase',
                    letterSpacing: '0.2em'
                }}>
                    Loading Assets
                </h2>
                <div style={{ 
                    width: 300, 
                    height: 4, 
                    background: 'rgba(255,255,255,0.1)', 
                    borderRadius: 2,
                    margin: '0 auto',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                    <div style={{ 
                        width: `${progress}%`, 
                        height: '100%', 
                        background: 'cyan', 
                        transition: 'width 0.2s ease' 
                    }} />
                </div>
                <p style={{ color: 'rgba(255,255,255,0.5)', marginTop: 10 }}>{Math.round(progress)}%</p>
            </div>
        </div>
    );
};

export default ThreeDLoader;
